import React, { useState, useEffect } from 'react';

interface TimeProps {
  countDownStart: number;
  onCountDownFinished?: () => void;
  reset: boolean;
}

const Time: React.FC<TimeProps> = ({ countDownStart, onCountDownFinished, reset }) => {
  const [seconds, setSeconds] = useState<number>(countDownStart);
  const [isActive, setIsActive] = useState<boolean>(true);

  const resetCountdown = () => {
    setIsActive(true);
    setSeconds(countDownStart);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if(reset){
        resetCountdown();
    }

    if (isActive) {
      interval = setInterval(() => {
        if (seconds === 0) {
          setIsActive(false);
          clearInterval(interval!);
          if (onCountDownFinished) {
            onCountDownFinished();
          }
        } else {
          setSeconds(prevSeconds => prevSeconds - 1);
        }
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval!);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isActive, seconds, onCountDownFinished, reset]);

  const formatTime = (time: number): string => {
    const minutes: number = Math.floor(time / 60);
    const seconds: number = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <span style={{fontWeight : 'bolder'}}>{formatTime(seconds)}</span>
  );
};

export default Time;
